"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PAYMENT = exports.UPDATE_BOOKING = exports.RESCHEDULE_BOOKING = exports.REDUCER_INITIATE_PAYMENT = exports.REDUCER_GET_PAYMENT_STATUS = exports.GET_BOOKING_DETAIL = exports.CONFIRM_SLOT = exports.BLOCK_SLOT = void 0;
const BLOCK_SLOT = exports.BLOCK_SLOT = 'blockSlot';
const GET_BOOKING_DETAIL = exports.GET_BOOKING_DETAIL = 'getBookingDetail';
const CONFIRM_SLOT = exports.CONFIRM_SLOT = 'confirmSlot';
const UPDATE_BOOKING = exports.UPDATE_BOOKING = 'updateBooking';
const REDUCER_INITIATE_PAYMENT = exports.REDUCER_INITIATE_PAYMENT = 'initiateHomecarePayment';
const REDUCER_GET_PAYMENT_STATUS = exports.REDUCER_GET_PAYMENT_STATUS = 'getHomecarePaymentOrderstatus';
const RESCHEDULE_BOOKING = exports.RESCHEDULE_BOOKING = 'rescheduleBooking';
const UPDATE_PAYMENT = exports.UPDATE_PAYMENT = 'updatePayment';